import React from 'react';

interface IntervalCellProps {
  interval: string;
}

const IntervalCell: React.FC<IntervalCellProps> = ({ interval }) => {
  return (
    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">
      {interval}
    </span>
  );
};

export default IntervalCell; 